module.exports = __webpack_public_path__ + "img/wolt-clone-banner.4c81c303.webp";